/**
 * Stock-level filter for the stock dashboard (WMS-32). "Likutis" (the on-hand
 * balance) drives the four options next to the search box.
 */
export type StockStatus = 'all' | 'in_stock' | 'out_of_stock' | 'low';

export const DEFAULT_STOCK_STATUS: StockStatus = 'in_stock';

export const STOCK_STATUS_OPTIONS: StockStatus[] = ['all', 'in_stock', 'out_of_stock', 'low'];

/**
 * True when a row's on-hand balance matches the selected stock status:
 * - `in_stock` — on hand above zero
 * - `out_of_stock` — nothing on hand
 * - `low` — at or below the SKU's low-water threshold ("slenkstis") but still
 *   above zero; a row without a threshold can never be "low"
 * - `all` — everything
 */
export function matchesStockStatus(
  status: StockStatus,
  row: { onHand: number; lowWaterQty: number | null },
): boolean {
  switch (status) {
    case 'in_stock':
      return row.onHand > 0;
    case 'out_of_stock':
      return row.onHand <= 0;
    case 'low':
      return row.lowWaterQty != null && row.onHand > 0 && row.onHand <= row.lowWaterQty;
    default:
      return true;
  }
}
